import { render, staticRenderFns } from "./newTreasureCard.vue?vue&type=template&id=e78b4daa&scoped=true&"
import script from "./newTreasureCard.vue?vue&type=script&lang=js&"
export * from "./newTreasureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78b4daa",
  null
  
)

export default component.exports